const en = {
  'meta.title': 'Tsudoi | Visual layout and batch image generation',
  'meta.description': 'Tsudoi creates invitations with visual text layout, CSV or TXT data filling, and high-resolution PNG or batch ZIP export.',
  'app.name': 'Tsudoi',
  'app.subtitle': 'Visual invitation studio',
  'language.label': 'Language',
  'language.zhCN': '简体中文',
  'language.zhTW': '繁體中文',
  'language.en': 'English',
  'language.de': 'Deutsch',
  'language.ja': '日本語',
  'language.ko': '한국어',
  'language.es': 'Español',
  'language.fr': 'Français',
  'theme.label': 'Appearance theme',
  'theme.system': 'Follow system',
  'theme.light': 'Light',
  'theme.dark': 'Dark',
  'section.background': '1. Background',
  'section.layers': '2. Text layers',
  'section.editor': '3. Edit selected text',
  'section.batch': '4. Batch data',
  'section.single': '5. Single download',
  'background.upload': 'Upload invitation background',
  'background.padding': 'Safe padding',
  'background.helper': 'Text snaps to canvas edges, center, safe area, and other text. Hold Alt to disable snapping temporarily.',
  'layers.add': 'Add text',
  'layers.defaultText': 'Text',
  'layers.empty': 'Empty text',
  'layers.deleteAria': 'Delete layer #{{index}}',
  'editor.textAria': 'Template text',
  'editor.textPlaceholder': 'Enter template text, including multiple lines and variables',
  'editor.tokenHelp': 'Insert variables and combine them freely with regular text:',
  'editor.tokenTxt': 'TXT data',
  'editor.tokenDate': 'Current date',
  'editor.tokenTime': 'Current time',
  'editor.tokenDateTime': 'Date and time',
  'editor.tokenUuid': 'Automatic UUID',
  'editor.csvPlaceholder': 'e.g. name',
  'editor.csvAria': 'CSV header',
  'editor.csvInsert': 'Insert CSV field',
  'editor.indexDigits': 'Index padding digits',
  'editor.indexInsert': 'Insert padded index',
  'editor.example': 'Example: Dear {{csv.name}}, date {{date}}, number {{index:3}}',
  'editor.font': 'Font',
  'editor.fontFallback': 'If an online font cannot load, a system font for the same language is used automatically.',
  'editor.fontGroupSystem': 'System fonts',
  'editor.fontGroupChinese': 'Chinese',
  'editor.fontGroupLatin': 'Latin',
  'editor.fontGroupJapanese': 'Japanese',
  'editor.fontGroupKorean': 'Korean',
  'editor.fontSystemSans': 'System sans-serif',
  'editor.fontSystemSerif': 'System serif',
  'editor.fontSystemKai': 'System Kai',
  'editor.fontSystemScript': 'System script',
  'editor.fontGreatVibes': 'Invitation script',
  'editor.fontPlayfair': 'Elegant serif',
  'editor.fontCormorant': 'Classic serif',
  'editor.fontSize': 'Font size',
  'editor.fontWeight': 'Font weight',
  'editor.weightLight': 'Light',
  'editor.weightRegular': 'Regular',
  'editor.weightSemibold': 'Semibold',
  'editor.weightBold': 'Bold',
  'editor.color': 'Color',
  'editor.alignment': 'Alignment',
  'editor.alignmentAria': 'Text alignment',
  'editor.alignLeft': 'Align left',
  'editor.alignCenter': 'Align center',
  'editor.alignRight': 'Align right',
  'editor.anchor': 'Anchor',
  'editor.anchorAria': '{{horizontal}} {{vertical}} anchor',
  'editor.anchorLeft': 'left',
  'editor.anchorCenter': 'center',
  'editor.anchorRight': 'right',
  'editor.anchorTop': 'top',
  'editor.anchorBottom': 'bottom',
  'editor.anchorHelp': 'The anchor fixes the text-box coordinate; wrapped content expands away from that point.',
  'editor.width': 'Width',
  'editor.widthAuto': 'Fit content',
  'editor.widthFixed': 'Fixed width',
  'editor.pixels': 'Pixels',
  'editor.resizeHelp': 'Drag the round blue handle to set a fixed width; it becomes square when fixed. Double-click the square handle to fit content again. It snaps to canvas edges, center, safe area, and other text; hold Alt to disable snapping.',
  'editor.letterSpacing': 'Letter spacing',
  'editor.stroke': 'Outline color',
  'editor.strokeWidth': 'Outline width',
  'data.import': 'Import {{type}}',
  'data.sourceTitle': 'Data source and examples',
  'data.hint': 'The data source is detected automatically from {{txt}} or {{csv.header}} in the template.',
  'data.conflict': 'TXT and CSV variables cannot be mixed',
  'data.none': 'Insert {{txt}} or {{csv.header}} before importing data',
  'data.imported': 'Imported {{count}} {{type}} records',
  'data.expandPreview': 'Expand preview',
  'data.closePreview': 'Close preview',
  'data.previewTitle': 'Data preview · {{count}} rows',
  'data.waiting': 'Waiting for a {{type}} file',
  'data.generating': 'Generating {{progress}}%',
  'data.download': 'Generate batch and download ZIP',
  'data.examples': 'Download examples',
  'data.exampleCsvSingle': 'CSV · Single field',
  'data.exampleCsvMultiple': 'CSV · Multiple fields',
  'data.exampleTxtNames': 'TXT · Names',
  'data.exampleTxtLines': 'TXT · Complete lines',
  'single.download': 'Download current image',
  'single.help': 'PNG is always generated at the background image’s original resolution, and all files stay on this device.',
  'advanced.title': 'Advanced features',
  'advanced.import': 'Import template',
  'advanced.export': 'Export template',
  'advanced.help': 'A template replaces text layers only; the current background remains unchanged.',
  'advanced.reset': 'Reset workspace data',
  'footer.github': 'View the Tsudoi source code on GitHub',
  'footer.navigation': 'Site information and contact',
  'guide.title': 'User guide',
  'footer.about': 'About',
  'footer.privacy': 'Privacy',
  'footer.terms': 'Terms',
  'footer.contact': 'Contact',
  'modal.deleteTitle': 'Delete text layer?',
  'modal.deleteBody': 'This removes the layer. If it contains data variables, the current imported data will also become invalid.',
  'modal.cancel': 'Cancel',
  'modal.delete': 'Delete',
  'modal.templateTitle': 'Replace current text layers?',
  'modal.templateBody': 'Importing a template replaces all text layers and safe padding while preserving the background.',
  'modal.import': 'Import template',
  'modal.resetTitle': 'Reset all workspace data?',
  'modal.resetBody': 'This removes the background, text layers, canvas settings, imported data, and saved recovery state. Language and theme preferences will remain unchanged.',
  'modal.reset': 'Reset data',
  'toast.errorTitle': 'Action not completed',
  'toast.unknown': 'An unknown error occurred',
  'toast.backgroundLoaded': 'Background loaded',
  'toast.dataImported': 'Data imported',
  'toast.dataImportedMessage': 'Imported records: {{count}}',
  'toast.imageGenerated': 'Image generated',
  'toast.imageSaved': 'The PNG was saved to the downloads folder',
  'toast.batchComplete': 'Batch generation complete',
  'toast.batchSaved': 'Packaged images: {{count}}',
  'toast.templateExported': 'Template exported',
  'toast.templateExportedMessage': 'The template does not contain the background or imported data',
  'toast.workspaceReset': 'Workspace reset',
  'toast.workspaceResetMessage': 'All editor data and saved recovery data have been cleared',
  'pwa.offlineTitle': 'Ready to use offline',
  'pwa.offlineMessage': 'Editor resources have been saved on this device.',
  'pwa.updateTitle': 'A new version is available',
  'pwa.updateMessage': 'Save or export the current template before updating.',
  'pwa.updateNow': 'Update now',
  'pwa.later': 'Later',
  'errors.uploadBackgroundFirst': 'Upload a real background image first',
  'errors.dataMismatch': 'Import data that matches the current variables',
  'errors.imageFile': 'Select an image file',
  'errors.imageDecode': 'The image could not be opened. Try another file.',
  'errors.renderPng': 'The PNG could not be generated. Try again.',
  'errors.placeholder': 'The built-in placeholder is unavailable',
  'errors.rowLimit': 'A batch supports up to {{max}} records; this file contains {{count}}',
  'errors.noData': 'The file contains no usable data',
  'errors.csvParse': 'CSV row {{row}} could not be parsed',
  'errors.csvMissingHeaders': 'CSV headers are missing: {{fields}}',
  'errors.bindingMissing': 'Insert a TXT or CSV data variable in the text first',
  'errors.bindingConflict': '{{txt}} and {{csv.*}} cannot be mixed in one template',
  'errors.needTxt': 'This template uses {{txt}}; import a TXT file',
  'errors.needCsv': 'This template uses CSV fields; import a CSV file',
  'errors.templateTooLarge': 'The template file cannot exceed 1 MB',
  'errors.templateInvalidJson': 'The template is not a valid JSON file',
  'errors.templateFieldInvalid': 'Template field {{field}} is invalid',
} as const;

type Messages = { [Key in keyof typeof en]: string };

const zhCN: Messages = {
  'meta.title': 'Tsudoi 在线邀请函生成器｜可视化排版与 CSV/TXT 批量生成高清 PNG',
  'meta.description': 'Tsudoi 是免费、重视隐私的在线邀请函生成器。上传底图，在画布中拖拽文字并调整字体、字号、颜色、描边、对齐与锚点；导入 CSV 或 TXT 批量填充姓名、日期、序号和 UUID，生成原图分辨率 PNG 与 ZIP。所有底图、名单、模板和结果仅在当前设备处理，不上传服务器，支持 PWA 安装与离线编辑。',
  'app.name': 'Tsudoi',
  'app.subtitle': '可视化邀请函工具',
  'language.label': '界面语言',
  'language.zhCN': '简体中文',
  'language.zhTW': '繁體中文',
  'language.en': 'English',
  'language.de': 'Deutsch',
  'language.ja': '日本語',
  'language.ko': '한국어',
  'language.es': 'Español',
  'language.fr': 'Français',
  'theme.label': '外观主题',
  'theme.system': '跟随系统',
  'theme.light': '浅色',
  'theme.dark': '深色',
  'section.background': '1. 底图',
  'section.layers': '2. 文本图层',
  'section.editor': '3. 编辑选中文本',
  'section.batch': '4. 批量数据',
  'section.single': '5. 单张下载',
  'background.upload': '上传邀请函底图',
  'background.padding': '安全内边距',
  'background.helper': '拖动文字时会吸附画布边缘、中心、安全区及其他文本；按住 Alt 可临时关闭吸附。',
  'layers.add': '添加文本',
  'layers.defaultText': '文字',
  'layers.empty': '空文本',
  'layers.deleteAria': '删除图层 #{{index}}',
  'editor.textAria': '模板文字',
  'editor.textPlaceholder': '输入模板文字，支持多行和变量',
  'editor.tokenHelp': '点击插入变量，可与普通文字自由拼接：',
  'editor.tokenTxt': 'TXT 数据',
  'editor.tokenDate': '当前日期',
  'editor.tokenTime': '当前时间',
  'editor.tokenDateTime': '日期时间',
  'editor.tokenUuid': '自动 UUID',
  'editor.csvPlaceholder': '例如 name',
  'editor.csvAria': 'CSV 表头',
  'editor.csvInsert': '插入 CSV 字段',
  'editor.indexDigits': '序号补零位数',
  'editor.indexInsert': '插入补零序号',
  'editor.example': '示例：尊敬的 {{csv.name}}，日期 {{date}}，编号 {{index:3}}',
  'editor.font': '字体',
  'editor.fontFallback': '网络字体无法加载时，会自动使用同语言的系统字体。',
  'editor.fontGroupSystem': '系统字体',
  'editor.fontGroupChinese': '中文',
  'editor.fontGroupLatin': '拉丁文字',
  'editor.fontGroupJapanese': '日文',
  'editor.fontGroupKorean': '韩文',
  'editor.fontSystemSans': '系统黑体',
  'editor.fontSystemSerif': '系统宋体',
  'editor.fontSystemKai': '系统楷体',
  'editor.fontSystemScript': '系统手写体',
  'editor.fontGreatVibes': '邀请函花体',
  'editor.fontPlayfair': '优雅衬线',
  'editor.fontCormorant': '古典衬线',
  'editor.fontSize': '字号',
  'editor.fontWeight': '字重',
  'editor.weightLight': '细',
  'editor.weightRegular': '常规',
  'editor.weightSemibold': '中粗',
  'editor.weightBold': '粗',
  'editor.color': '颜色',
  'editor.alignment': '对齐',
  'editor.alignmentAria': '文字对齐',
  'editor.alignLeft': '左对齐',
  'editor.alignCenter': '居中对齐',
  'editor.alignRight': '右对齐',
  'editor.anchor': '锚点',
  'editor.anchorAria': '{{horizontal}}{{vertical}}锚点',
  'editor.anchorLeft': '左侧',
  'editor.anchorCenter': '中间',
  'editor.anchorRight': '右侧',
  'editor.anchorTop': '顶部',
  'editor.anchorBottom': '底部',
  'editor.anchorHelp': '锚点固定文本框坐标；换行后内容沿锚点方向扩展。',
  'editor.width': '宽度',
  'editor.widthAuto': '随内容',
  'editor.widthFixed': '固定宽度',
  'editor.pixels': '像素',
  'editor.resizeHelp': '拖动蓝色圆形手柄可设置固定宽度，固定后手柄变为方形；双击方形手柄可恢复随内容。调整时会吸附画布边缘、中心、安全区及其他文本，按住 Alt 可临时关闭吸附。',
  'editor.letterSpacing': '字距',
  'editor.stroke': '描边颜色',
  'editor.strokeWidth': '描边线宽',
  'data.import': '导入 {{type}}',
  'data.sourceTitle': '数据源与示例',
  'data.hint': '系统按模板中的 {{txt}} 或 {{csv.表头}} 自动判断数据源。',
  'data.conflict': 'TXT 与 CSV 变量不能混用',
  'data.none': '插入 {{txt}} 或 {{csv.表头}} 后可导入数据',
  'data.imported': '已导入 {{count}} 条 {{type}} 数据',
  'data.expandPreview': '展开预览',
  'data.closePreview': '关闭预览',
  'data.previewTitle': '数据预览 · {{count}} 条',
  'data.waiting': '等待导入 {{type}} 文件',
  'data.generating': '生成中 {{progress}}%',
  'data.download': '批量生成并下载 ZIP',
  'data.examples': '下载示例',
  'data.exampleCsvSingle': 'CSV · 单字段',
  'data.exampleCsvMultiple': 'CSV · 多字段',
  'data.exampleTxtNames': 'TXT · 姓名',
  'data.exampleTxtLines': 'TXT · 完整文本',
  'single.download': '下载当前图片',
  'single.help': '始终按底图原始分辨率生成 PNG，所有文件只在本地设备处理。',
  'advanced.title': '高级功能',
  'advanced.import': '导入模板',
  'advanced.export': '导出模板',
  'advanced.help': '模板只替换文本图层，当前底图保持不变。',
  'advanced.reset': '重置工作区数据',
  'footer.github': '在 GitHub 查看 Tsudoi 源代码',
  'footer.navigation': '站点信息与联系方式',
  'guide.title': '使用教程',
  'footer.about': '关于',
  'footer.privacy': '隐私',
  'footer.terms': '条款',
  'footer.contact': '联系',
  'modal.deleteTitle': '删除文本图层？',
  'modal.deleteBody': '此操作会移除该图层；如果它包含数据变量，当前导入数据也会失效。',
  'modal.cancel': '取消',
  'modal.delete': '删除',
  'modal.templateTitle': '替换当前文本图层？',
  'modal.templateBody': '导入模板会替换当前全部文本图层和安全内边距，底图保持不变。',
  'modal.import': '导入模板',
  'modal.resetTitle': '重置全部工作区数据？',
  'modal.resetBody': '此操作会清除底图、文字图层、画布设置、导入数据和本地恢复记录，但保留界面语言与主题偏好。',
  'modal.reset': '重置数据',
  'toast.errorTitle': '操作未完成',
  'toast.unknown': '发生未知错误',
  'toast.backgroundLoaded': '底图已载入',
  'toast.dataImported': '数据已导入',
  'toast.dataImportedMessage': '共 {{count}} 条记录',
  'toast.imageGenerated': '图片已生成',
  'toast.imageSaved': 'PNG 已保存到下载目录',
  'toast.batchComplete': '批量生成完成',
  'toast.batchSaved': '{{count}} 张图片已打包下载',
  'toast.templateExported': '模板已导出',
  'toast.templateExportedMessage': '模板不包含底图和导入数据',
  'toast.workspaceReset': '工作区已重置',
  'toast.workspaceResetMessage': '编辑器数据和本地恢复记录已全部清除',
  'pwa.offlineTitle': '已经可以离线使用',
  'pwa.offlineMessage': '编辑器资源已保存到当前设备。',
  'pwa.updateTitle': '发现新版本',
  'pwa.updateMessage': '更新前请先保存或导出当前模板。',
  'pwa.updateNow': '立即更新',
  'pwa.later': '稍后',
  'errors.uploadBackgroundFirst': '请先上传正式底图',
  'errors.dataMismatch': '请导入与当前变量匹配的数据',
  'errors.imageFile': '请选择图片文件',
  'errors.imageDecode': '无法打开该图片，请尝试其他文件。',
  'errors.renderPng': '未能生成 PNG，请重试',
  'errors.placeholder': '内置占位图不可用',
  'errors.rowLimit': '单次最多导入 {{max}} 条数据，当前文件有 {{count}} 条',
  'errors.noData': '文件中没有可用数据',
  'errors.csvParse': 'CSV 第 {{row}} 行解析失败',
  'errors.csvMissingHeaders': 'CSV 缺少表头：{{fields}}',
  'errors.bindingMissing': '请先在文本中插入 TXT 或 CSV 数据变量',
  'errors.bindingConflict': '{{txt}} 与 {{csv.*}} 不能在同一模板中混用',
  'errors.needTxt': '当前模板使用 {{txt}}，请导入 TXT 文件',
  'errors.needCsv': '当前模板使用 CSV 字段，请导入 CSV 文件',
  'errors.templateTooLarge': '模板文件不能超过 1 MB',
  'errors.templateInvalidJson': '模板不是有效的 JSON 文件',
  'errors.templateFieldInvalid': '模板字段 {{field}} 无效',
};

const zhTW: Messages = {
  ...zhCN,
  'meta.title': 'Tsudoi 線上邀請函產生器｜視覺化排版與 CSV/TXT 批次產生高畫質 PNG',
  'meta.description': 'Tsudoi 是免費且重視隱私的線上邀請函產生器。上傳底圖，在畫布中拖曳文字並調整字型、字號、顏色、描邊、對齊與錨點；匯入 CSV 或 TXT 批次填入姓名、日期、序號和 UUID，產生原圖解析度 PNG 與 ZIP。所有底圖、名單、範本和結果僅在目前裝置處理，不上傳伺服器，並支援 PWA 安裝與離線編輯。',
  'app.name': 'Tsudoi',
  'app.subtitle': '視覺化邀請函工具',
  'language.label': '介面語言',
  'theme.label': '外觀主題',
  'theme.system': '跟隨系統',
  'theme.light': '淺色',
  'theme.dark': '深色',
  'section.background': '1. 底圖',
  'section.layers': '2. 文字圖層',
  'section.editor': '3. 編輯選取文字',
  'section.batch': '4. 批次資料',
  'section.single': '5. 單張下載',
  'background.upload': '上傳邀請函底圖',
  'background.padding': '安全內距',
  'background.helper': '拖曳文字時會吸附畫布邊緣、中心、安全區及其他文字；按住 Alt 可暫時關閉吸附。',
  'layers.add': '新增文字',
  'layers.defaultText': '文字',
  'layers.empty': '空白文字',
  'layers.deleteAria': '刪除圖層 #{{index}}',
  'editor.textAria': '範本文字',
  'editor.textPlaceholder': '輸入範本文字，支援多行與變數',
  'editor.tokenHelp': '點擊插入變數，可與一般文字自由組合：',
  'editor.tokenTxt': 'TXT 資料',
  'editor.tokenDate': '目前日期',
  'editor.tokenTime': '目前時間',
  'editor.tokenDateTime': '日期時間',
  'editor.tokenUuid': '自動 UUID',
  'editor.csvPlaceholder': '例如 name',
  'editor.csvAria': 'CSV 欄名',
  'editor.csvInsert': '插入 CSV 欄位',
  'editor.indexDigits': '序號補零位數',
  'editor.indexInsert': '插入補零序號',
  'editor.example': '範例：敬愛的 {{csv.name}}，日期 {{date}}，編號 {{index:3}}',
  'editor.font': '字型',
  'editor.fontFallback': '網路字型無法載入時，會自動使用同語言的系統字型。',
  'editor.fontGroupSystem': '系統字型',
  'editor.fontGroupChinese': '中文',
  'editor.fontGroupLatin': '拉丁文字',
  'editor.fontGroupJapanese': '日文',
  'editor.fontGroupKorean': '韓文',
  'editor.fontSystemSans': '系統黑體',
  'editor.fontSystemSerif': '系統明體',
  'editor.fontSystemKai': '系統楷體',
  'editor.fontSystemScript': '系統手寫體',
  'editor.fontGreatVibes': '邀請函花體',
  'editor.fontPlayfair': '優雅襯線',
  'editor.fontCormorant': '古典襯線',
  'editor.fontSize': '字級',
  'editor.fontWeight': '字重',
  'editor.weightLight': '細',
  'editor.weightRegular': '一般',
  'editor.weightSemibold': '半粗',
  'editor.weightBold': '粗',
  'editor.color': '顏色',
  'editor.alignment': '對齊',
  'editor.alignmentAria': '文字對齊',
  'editor.alignLeft': '靠左對齊',
  'editor.alignCenter': '置中對齊',
  'editor.alignRight': '靠右對齊',
  'editor.anchor': '錨點',
  'editor.anchorAria': '{{horizontal}}{{vertical}}錨點',
  'editor.anchorLeft': '左側',
  'editor.anchorCenter': '中央',
  'editor.anchorRight': '右側',
  'editor.anchorTop': '頂部',
  'editor.anchorBottom': '底部',
  'editor.anchorHelp': '錨點固定文字框座標；換行後內容會沿錨點方向延伸。',
  'editor.width': '寬度',
  'editor.widthAuto': '隨內容',
  'editor.widthFixed': '固定寬度',
  'editor.pixels': '像素',
  'editor.resizeHelp': '拖曳藍色圓形控制點可設定固定寬度，固定後控制點會變成方形；雙擊方形控制點可恢復隨內容。調整時會吸附畫布邊緣、中心、安全區及其他文字，按住 Alt 可暫時關閉吸附。',
  'editor.letterSpacing': '字距',
  'editor.stroke': '描邊顏色',
  'editor.strokeWidth': '描邊線寬',
  'data.import': '匯入 {{type}}',
  'data.sourceTitle': '資料來源與範例',
  'data.hint': '系統會依範本中的 {{txt}} 或 {{csv.欄名}} 自動判斷資料來源。',
  'data.conflict': 'TXT 與 CSV 變數不可混用',
  'data.none': '插入 {{txt}} 或 {{csv.欄名}} 後即可匯入資料',
  'data.imported': '已匯入 {{count}} 筆 {{type}} 資料',
  'data.expandPreview': '展開預覽',
  'data.closePreview': '關閉預覽',
  'data.previewTitle': '資料預覽 · {{count}} 筆',
  'data.waiting': '等待匯入 {{type}} 檔案',
  'data.generating': '產生中 {{progress}}%',
  'data.download': '批次產生並下載 ZIP',
  'data.examples': '下載範例',
  'data.exampleCsvSingle': 'CSV · 單欄位',
  'data.exampleCsvMultiple': 'CSV · 多欄位',
  'data.exampleTxtNames': 'TXT · 姓名',
  'data.exampleTxtLines': 'TXT · 完整文字',
  'single.download': '下載目前圖片',
  'single.help': '一律依底圖原始解析度產生 PNG，所有檔案只在本機裝置處理。',
  'advanced.title': '進階功能',
  'advanced.import': '匯入範本',
  'advanced.export': '匯出範本',
  'advanced.help': '範本只會取代文字圖層，目前底圖維持不變。',
  'advanced.reset': '重設工作區資料',
  'footer.github': '在 GitHub 查看 Tsudoi 原始碼',
  'footer.navigation': '網站資訊與聯絡方式',
  'guide.title': '使用教學',
  'footer.about': '關於',
  'footer.privacy': '隱私',
  'footer.terms': '條款',
  'footer.contact': '聯絡',
  'modal.deleteTitle': '刪除文字圖層？',
  'modal.deleteBody': '此操作會移除該圖層；若包含資料變數，目前匯入的資料也會失效。',
  'modal.cancel': '取消',
  'modal.delete': '刪除',
  'modal.templateTitle': '取代目前文字圖層？',
  'modal.templateBody': '匯入範本會取代全部文字圖層與安全內距，底圖維持不變。',
  'modal.import': '匯入範本',
  'modal.resetTitle': '重設全部工作區資料？',
  'modal.resetBody': '此操作會清除底圖、文字圖層、畫布設定、匯入資料和本機復原記錄，但保留介面語言與主題偏好。',
  'modal.reset': '重設資料',
  'toast.errorTitle': '操作未完成',
  'toast.unknown': '發生未知錯誤',
  'toast.backgroundLoaded': '底圖已載入',
  'toast.dataImported': '資料已匯入',
  'toast.dataImportedMessage': '共 {{count}} 筆記錄',
  'toast.imageGenerated': '圖片已產生',
  'toast.imageSaved': 'PNG 已儲存至下載資料夾',
  'toast.batchComplete': '批次產生完成',
  'toast.batchSaved': '已打包下載 {{count}} 張圖片',
  'toast.templateExported': '範本已匯出',
  'toast.templateExportedMessage': '範本不包含底圖與匯入資料',
  'toast.workspaceReset': '工作區已重設',
  'toast.workspaceResetMessage': '編輯器資料和本機復原記錄已全部清除',
  'pwa.offlineTitle': '現在可以離線使用',
  'pwa.offlineMessage': '編輯器資源已儲存至目前裝置。',
  'pwa.updateTitle': '有新版本可用',
  'pwa.updateMessage': '更新前請先儲存或匯出目前範本。',
  'pwa.updateNow': '立即更新',
  'pwa.later': '稍後',
  'errors.uploadBackgroundFirst': '請先上傳正式底圖',
  'errors.dataMismatch': '請匯入與目前變數相符的資料',
  'errors.imageFile': '請選擇圖片檔案',
  'errors.imageDecode': '無法開啟此圖片，請嘗試其他檔案。',
  'errors.renderPng': '無法產生 PNG，請再試一次',
  'errors.placeholder': '內建預留圖片無法使用',
  'errors.rowLimit': '單次最多匯入 {{max}} 筆資料，目前檔案有 {{count}} 筆',
  'errors.noData': '檔案中沒有可用資料',
  'errors.csvParse': 'CSV 第 {{row}} 列解析失敗',
  'errors.csvMissingHeaders': 'CSV 缺少欄名：{{fields}}',
  'errors.bindingMissing': '請先在文字中插入 TXT 或 CSV 資料變數',
  'errors.bindingConflict': '{{txt}} 與 {{csv.*}} 不可在同一範本中混用',
  'errors.needTxt': '目前範本使用 {{txt}}，請匯入 TXT 檔案',
  'errors.needCsv': '目前範本使用 CSV 欄位，請匯入 CSV 檔案',
  'errors.templateTooLarge': '範本檔案不可超過 1 MB',
  'errors.templateInvalidJson': '範本不是有效的 JSON 檔案',
  'errors.templateFieldInvalid': '範本欄位 {{field}} 無效',
};

const de: Messages = {
  ...en,
  'meta.title': 'Tsudoi | Visuelles Layout und Stapelgenerierung',
  'meta.description': 'Tsudoi ist ein universelles Werkzeug für visuelles Einladungslayout, CSV-/TXT-Daten und den Export als PNG oder ZIP.',
  'app.subtitle': 'Visuelles Einladungsstudio',
  'language.label': 'Sprache',
  'theme.label': 'Darstellung',
  'theme.system': 'Systemeinstellung',
  'theme.light': 'Hell',
  'theme.dark': 'Dunkel',
  'section.background': '1. Hintergrund',
  'section.layers': '2. Textebenen',
  'section.editor': '3. Ausgewählten Text bearbeiten',
  'section.batch': '4. Seriendaten',
  'section.single': '5. Einzelbild',
  'background.upload': 'Einladungshintergrund hochladen',
  'background.padding': 'Sicherheitsabstand',
  'background.helper': 'Text rastet an Kanten, Mitte, Sicherheitsbereich und anderen Texten ein. Mit Alt wird das Einrasten vorübergehend deaktiviert.',
  'layers.add': 'Text hinzufügen',
  'layers.defaultText': 'Text',
  'layers.empty': 'Leerer Text',
  'layers.deleteAria': 'Ebene #{{index}} löschen',
  'editor.textAria': 'Vorlagentext',
  'editor.textPlaceholder': 'Vorlagentext mit mehreren Zeilen und Variablen eingeben',
  'editor.tokenHelp': 'Variablen einfügen und frei mit normalem Text kombinieren:',
  'editor.tokenTxt': 'TXT-Daten',
  'editor.tokenDate': 'Aktuelles Datum',
  'editor.tokenTime': 'Aktuelle Uhrzeit',
  'editor.tokenDateTime': 'Datum und Uhrzeit',
  'editor.tokenUuid': 'Automatische UUID',
  'editor.csvPlaceholder': 'z. B. name',
  'editor.csvAria': 'CSV-Spaltenname',
  'editor.csvInsert': 'CSV-Feld einfügen',
  'editor.indexDigits': 'Stellen für führende Nullen',
  'editor.indexInsert': 'Aufgefüllten Index einfügen',
  'editor.example': 'Beispiel: Hallo {{csv.name}}, Datum {{date}}, Nummer {{index:3}}',
  'editor.font': 'Schriftart',
  'editor.fontFallback': 'Kann eine Online-Schrift nicht geladen werden, wird automatisch eine passende Systemschrift verwendet.',
  'editor.fontGroupSystem': 'Systemschriften',
  'editor.fontGroupChinese': 'Chinesisch',
  'editor.fontGroupLatin': 'Lateinisch',
  'editor.fontGroupJapanese': 'Japanisch',
  'editor.fontGroupKorean': 'Koreanisch',
  'editor.fontSystemSans': 'Systemschrift ohne Serifen',
  'editor.fontSystemSerif': 'Systemschrift mit Serifen',
  'editor.fontSystemKai': 'Systemschrift Kai',
  'editor.fontSystemScript': 'System-Handschrift',
  'editor.fontGreatVibes': 'Einladungs-Schreibschrift',
  'editor.fontPlayfair': 'Elegante Serifenschrift',
  'editor.fontCormorant': 'Klassische Serifenschrift',
  'editor.fontSize': 'Schriftgröße',
  'editor.fontWeight': 'Schriftstärke',
  'editor.weightLight': 'Leicht',
  'editor.weightRegular': 'Normal',
  'editor.weightSemibold': 'Halbfett',
  'editor.weightBold': 'Fett',
  'editor.color': 'Farbe',
  'editor.alignment': 'Ausrichtung',
  'editor.alignmentAria': 'Textausrichtung',
  'editor.alignLeft': 'Linksbündig',
  'editor.alignCenter': 'Zentriert',
  'editor.alignRight': 'Rechtsbündig',
  'editor.anchor': 'Anker',
  'editor.anchorAria': 'Anker {{horizontal}} {{vertical}}',
  'editor.anchorLeft': 'links',
  'editor.anchorCenter': 'mittig',
  'editor.anchorRight': 'rechts',
  'editor.anchorTop': 'oben',
  'editor.anchorBottom': 'unten',
  'editor.anchorHelp': 'Der Anker fixiert die Koordinate des Textfelds; umbrochener Inhalt wächst von diesem Punkt aus.',
  'editor.width': 'Breite',
  'editor.widthAuto': 'An Inhalt anpassen',
  'editor.widthFixed': 'Feste Breite',
  'editor.pixels': 'Pixel',
  'editor.resizeHelp': 'Ziehe den runden blauen Griff, um eine feste Breite festzulegen; danach wird er eckig. Ein Doppelklick auf den eckigen Griff passt die Breite wieder an den Inhalt an. Der Griff rastet an Kanten, Mitte, Sicherheitsbereich und anderen Texten ein; Alt deaktiviert das Einrasten.',
  'editor.letterSpacing': 'Zeichenabstand',
  'editor.stroke': 'Konturfarbe',
  'editor.strokeWidth': 'Konturbreite',
  'data.import': '{{type}} importieren',
  'data.sourceTitle': 'Datenquelle und Beispiele',
  'data.hint': 'Die Datenquelle wird anhand von {{txt}} oder {{csv.spalte}} in der Vorlage automatisch erkannt.',
  'data.conflict': 'TXT- und CSV-Variablen können nicht kombiniert werden',
  'data.none': 'Vor dem Import {{txt}} oder {{csv.spalte}} einfügen',
  'data.imported': '{{count}} {{type}}-Datensätze importiert',
  'data.expandPreview': 'Vorschau öffnen',
  'data.closePreview': 'Vorschau schließen',
  'data.previewTitle': 'Datenvorschau · {{count}} Zeilen',
  'data.waiting': 'Warten auf eine {{type}}-Datei',
  'data.generating': 'Wird erzeugt: {{progress}} %',
  'data.download': 'Stapel erzeugen und ZIP herunterladen',
  'data.examples': 'Beispiele herunterladen',
  'data.exampleCsvSingle': 'CSV · Ein Feld',
  'data.exampleCsvMultiple': 'CSV · Mehrere Felder',
  'data.exampleTxtNames': 'TXT · Namen',
  'data.exampleTxtLines': 'TXT · Vollständige Zeilen',
  'single.download': 'Aktuelles Bild herunterladen',
  'single.help': 'PNG wird immer in der Originalauflösung des Hintergrundbilds erzeugt; alle Dateien bleiben auf diesem Gerät.',
  'advanced.title': 'Erweiterte Funktionen',
  'advanced.import': 'Vorlage importieren',
  'advanced.export': 'Vorlage exportieren',
  'advanced.help': 'Eine Vorlage ersetzt nur Textebenen; der aktuelle Hintergrund bleibt unverändert.',
  'advanced.reset': 'Arbeitsbereich zurücksetzen',
  'footer.github': 'Quellcode von Tsudoi auf GitHub ansehen',
  'footer.navigation': 'Website-Informationen und Kontakt',
  'guide.title': 'Anleitung',
  'footer.about': 'Über',
  'footer.privacy': 'Datenschutz',
  'footer.terms': 'Bedingungen',
  'footer.contact': 'Kontakt',
  'modal.deleteTitle': 'Textebene löschen?',
  'modal.deleteBody': 'Die Ebene wird entfernt. Enthält sie Datenvariablen, werden die aktuell importierten Daten ebenfalls ungültig.',
  'modal.cancel': 'Abbrechen',
  'modal.delete': 'Löschen',
  'modal.templateTitle': 'Aktuelle Textebenen ersetzen?',
  'modal.templateBody': 'Der Vorlagenimport ersetzt alle Textebenen und den Sicherheitsabstand; der Hintergrund bleibt erhalten.',
  'modal.import': 'Vorlage importieren',
  'modal.resetTitle': 'Alle Arbeitsbereichsdaten zurücksetzen?',
  'modal.resetBody': 'Hintergrund, Textebenen, Leinwandeinstellungen, importierte Daten und lokale Wiederherstellungsdaten werden gelöscht. Sprache und Design bleiben erhalten.',
  'modal.reset': 'Daten zurücksetzen',
  'toast.errorTitle': 'Aktion nicht abgeschlossen',
  'toast.unknown': 'Ein unbekannter Fehler ist aufgetreten',
  'toast.backgroundLoaded': 'Hintergrund geladen',
  'toast.dataImported': 'Daten importiert',
  'toast.dataImportedMessage': 'Importierte Datensätze: {{count}}',
  'toast.imageGenerated': 'Bild erzeugt',
  'toast.imageSaved': 'Die PNG-Datei wurde im Download-Ordner gespeichert',
  'toast.batchComplete': 'Stapelgenerierung abgeschlossen',
  'toast.batchSaved': 'Verpackte Bilder: {{count}}',
  'toast.templateExported': 'Vorlage exportiert',
  'toast.templateExportedMessage': 'Die Vorlage enthält weder Hintergrund noch importierte Daten',
  'toast.workspaceReset': 'Arbeitsbereich zurückgesetzt',
  'toast.workspaceResetMessage': 'Editor- und Wiederherstellungsdaten wurden gelöscht',
  'pwa.offlineTitle': 'Offline verfügbar',
  'pwa.offlineMessage': 'Die Editor-Ressourcen wurden auf diesem Gerät gespeichert.',
  'pwa.updateTitle': 'Eine neue Version ist verfügbar',
  'pwa.updateMessage': 'Vor dem Aktualisieren die aktuelle Vorlage speichern oder exportieren.',
  'pwa.updateNow': 'Jetzt aktualisieren',
  'pwa.later': 'Später',
  'errors.uploadBackgroundFirst': 'Zuerst ein echtes Hintergrundbild hochladen',
  'errors.dataMismatch': 'Daten importieren, die zu den aktuellen Variablen passen',
  'errors.imageFile': 'Eine Bilddatei auswählen',
  'errors.imageDecode': 'Das Bild konnte nicht geöffnet werden. Bitte eine andere Datei versuchen.',
  'errors.renderPng': 'PNG konnte nicht erzeugt werden. Bitte erneut versuchen.',
  'errors.placeholder': 'Der integrierte Platzhalter ist nicht verfügbar',
  'errors.rowLimit': 'Pro Stapel sind höchstens {{max}} Datensätze möglich; diese Datei enthält {{count}}',
  'errors.noData': 'Die Datei enthält keine verwendbaren Daten',
  'errors.csvParse': 'CSV-Zeile {{row}} konnte nicht gelesen werden',
  'errors.csvMissingHeaders': 'Fehlende CSV-Spalten: {{fields}}',
  'errors.bindingMissing': 'Zuerst eine TXT- oder CSV-Datenvariable in den Text einfügen',
  'errors.bindingConflict': '{{txt}} und {{csv.*}} können nicht in einer Vorlage kombiniert werden',
  'errors.needTxt': 'Diese Vorlage verwendet {{txt}}; eine TXT-Datei importieren',
  'errors.needCsv': 'Diese Vorlage verwendet CSV-Felder; eine CSV-Datei importieren',
  'errors.templateTooLarge': 'Die Vorlagendatei darf höchstens 1 MB groß sein',
  'errors.templateInvalidJson': 'Die Vorlage ist keine gültige JSON-Datei',
  'errors.templateFieldInvalid': 'Vorlagenfeld {{field}} ist ungültig',
};

const ja: Messages = {
  ...en,
  'meta.title': 'Tsudoi | ビジュアル編集と一括画像生成',
  'meta.description': 'Tsudoi は、テキストのビジュアル配置、CSV/TXT データ差し込み、高解像度 PNG と ZIP の一括書き出しに対応した汎用招待状作成ツールです。',
  'app.name': 'Tsudoi',
  'app.subtitle': 'ビジュアル招待状ツール',
  'language.label': '表示言語',
  'theme.label': '外観テーマ',
  'theme.system': 'システム設定',
  'theme.light': 'ライト',
  'theme.dark': 'ダーク',
  'section.background': '1. 背景画像',
  'section.layers': '2. テキストレイヤー',
  'section.editor': '3. 選択中のテキストを編集',
  'section.batch': '4. 一括データ',
  'section.single': '5. 1枚をダウンロード',
  'background.upload': '招待状の背景画像をアップロード',
  'background.padding': '安全余白',
  'background.helper': 'テキストはキャンバス端、中央、安全領域、ほかのテキストへスナップします。Alt キーで一時的に無効化できます。',
  'layers.add': 'テキストを追加',
  'layers.defaultText': 'テキスト',
  'layers.empty': '空のテキスト',
  'layers.deleteAria': 'レイヤー #{{index}} を削除',
  'editor.textAria': 'テンプレートテキスト',
  'editor.textPlaceholder': '複数行や変数を含むテンプレートテキストを入力',
  'editor.tokenHelp': '変数を挿入し、通常のテキストと自由に組み合わせられます：',
  'editor.tokenTxt': 'TXT データ',
  'editor.tokenDate': '現在の日付',
  'editor.tokenTime': '現在の時刻',
  'editor.tokenDateTime': '日付と時刻',
  'editor.tokenUuid': '自動 UUID',
  'editor.csvPlaceholder': '例：name',
  'editor.csvAria': 'CSV 見出し',
  'editor.csvInsert': 'CSV フィールドを挿入',
  'editor.indexDigits': '連番のゼロ埋め桁数',
  'editor.indexInsert': 'ゼロ埋め連番を挿入',
  'editor.example': '例：{{csv.name}} 様、日付 {{date}}、番号 {{index:3}}',
  'editor.font': 'フォント',
  'editor.fontFallback': 'オンラインフォントを読み込めない場合、同じ言語のシステムフォントへ自動的に切り替わります。',
  'editor.fontGroupSystem': 'システムフォント',
  'editor.fontGroupChinese': '中国語',
  'editor.fontGroupLatin': 'ラテン文字',
  'editor.fontGroupJapanese': '日本語',
  'editor.fontGroupKorean': '韓国語',
  'editor.fontSystemSans': 'システムゴシック',
  'editor.fontSystemSerif': 'システム明朝',
  'editor.fontSystemKai': 'システム楷書',
  'editor.fontSystemScript': 'システム手書き',
  'editor.fontGreatVibes': '招待状スクリプト',
  'editor.fontPlayfair': '上品なセリフ',
  'editor.fontCormorant': 'クラシックセリフ',
  'editor.fontSize': '文字サイズ',
  'editor.fontWeight': '文字の太さ',
  'editor.weightLight': '細字',
  'editor.weightRegular': '標準',
  'editor.weightSemibold': '中太',
  'editor.weightBold': '太字',
  'editor.color': '色',
  'editor.alignment': '揃え',
  'editor.alignmentAria': 'テキストの揃え',
  'editor.alignLeft': '左揃え',
  'editor.alignCenter': '中央揃え',
  'editor.alignRight': '右揃え',
  'editor.anchor': 'アンカー',
  'editor.anchorAria': '{{horizontal}}{{vertical}}アンカー',
  'editor.anchorLeft': '左',
  'editor.anchorCenter': '中央',
  'editor.anchorRight': '右',
  'editor.anchorTop': '上',
  'editor.anchorBottom': '下',
  'editor.anchorHelp': 'アンカーはテキストボックスの座標を固定し、折り返した内容はその位置から広がります。',
  'editor.width': '幅',
  'editor.widthAuto': '内容に合わせる',
  'editor.widthFixed': '固定幅',
  'editor.pixels': 'ピクセル',
  'editor.resizeHelp': '青い丸形ハンドルをドラッグすると固定幅になり、ハンドルが四角形に変わります。四角形をダブルクリックすると内容に合わせる状態へ戻ります。キャンバス端、中央、安全領域、ほかのテキストへスナップし、Alt キーで一時的に無効化できます。',
  'editor.letterSpacing': '字間',
  'editor.stroke': 'アウトライン色',
  'editor.strokeWidth': 'アウトライン幅',
  'data.import': '{{type}} を読み込む',
  'data.sourceTitle': 'データソースとサンプル',
  'data.hint': 'テンプレート内の {{txt}} または {{csv.見出し}} からデータ形式を自動判定します。',
  'data.conflict': 'TXT と CSV の変数は併用できません',
  'data.none': '{{txt}} または {{csv.見出し}} を挿入するとデータを読み込めます',
  'data.imported': '{{type}} データを {{count}} 件読み込みました',
  'data.expandPreview': 'プレビューを開く',
  'data.closePreview': 'プレビューを閉じる',
  'data.previewTitle': 'データプレビュー · {{count}} 件',
  'data.waiting': '{{type}} ファイルを待っています',
  'data.generating': '生成中 {{progress}}%',
  'data.download': '一括生成して ZIP をダウンロード',
  'data.examples': 'サンプルをダウンロード',
  'data.exampleCsvSingle': 'CSV · 1フィールド',
  'data.exampleCsvMultiple': 'CSV · 複数フィールド',
  'data.exampleTxtNames': 'TXT · 名前',
  'data.exampleTxtLines': 'TXT · 完成テキスト',
  'single.download': '現在の画像をダウンロード',
  'single.help': 'PNG は常に背景画像の元の解像度で生成され、すべてのファイルはこのデバイス内で処理されます。',
  'advanced.title': '高度な機能',
  'advanced.import': 'テンプレートを読み込む',
  'advanced.export': 'テンプレートを書き出す',
  'advanced.help': 'テンプレートはテキストレイヤーだけを置き換え、現在の背景画像は維持します。',
  'advanced.reset': 'ワークスペースデータをリセット',
  'footer.github': 'GitHub で Tsudoi のソースコードを表示',
  'footer.navigation': 'サイト情報とお問い合わせ',
  'guide.title': '使い方ガイド',
  'footer.about': '概要',
  'footer.privacy': 'プライバシー',
  'footer.terms': '利用規約',
  'footer.contact': 'お問い合わせ',
  'modal.deleteTitle': 'テキストレイヤーを削除しますか？',
  'modal.deleteBody': 'このレイヤーを削除します。データ変数が含まれる場合、現在読み込まれているデータも無効になります。',
  'modal.cancel': 'キャンセル',
  'modal.delete': '削除',
  'modal.templateTitle': '現在のテキストレイヤーを置き換えますか？',
  'modal.templateBody': 'テンプレートを読み込むと、すべてのテキストレイヤーと安全余白が置き換わり、背景画像は維持されます。',
  'modal.import': 'テンプレートを読み込む',
  'modal.resetTitle': 'ワークスペースデータをすべてリセットしますか？',
  'modal.resetBody': '背景画像、テキストレイヤー、キャンバス設定、読み込みデータ、復元用の保存データを削除します。言語とテーマ設定は保持されます。',
  'modal.reset': 'データをリセット',
  'toast.errorTitle': '操作を完了できませんでした',
  'toast.unknown': '不明なエラーが発生しました',
  'toast.backgroundLoaded': '背景画像を読み込みました',
  'toast.dataImported': 'データを読み込みました',
  'toast.dataImportedMessage': '読み込み件数：{{count}}',
  'toast.imageGenerated': '画像を生成しました',
  'toast.imageSaved': 'PNG をダウンロードフォルダーに保存しました',
  'toast.batchComplete': '一括生成が完了しました',
  'toast.batchSaved': '{{count}} 枚の画像を ZIP にまとめました',
  'toast.templateExported': 'テンプレートを書き出しました',
  'toast.templateExportedMessage': 'テンプレートには背景画像と読み込みデータは含まれません',
  'toast.workspaceReset': 'ワークスペースをリセットしました',
  'toast.workspaceResetMessage': 'エディターデータと復元用データをすべて削除しました',
  'pwa.offlineTitle': 'オフラインで利用できます',
  'pwa.offlineMessage': 'エディターのリソースをこのデバイスに保存しました。',
  'pwa.updateTitle': '新しいバージョンがあります',
  'pwa.updateMessage': '更新前に現在のテンプレートを保存または書き出してください。',
  'pwa.updateNow': '今すぐ更新',
  'pwa.later': 'あとで',
  'errors.uploadBackgroundFirst': '先に正式な背景画像をアップロードしてください',
  'errors.dataMismatch': '現在の変数に合うデータを読み込んでください',
  'errors.imageFile': '画像ファイルを選択してください',
  'errors.imageDecode': '画像を開けませんでした。別のファイルをお試しください。',
  'errors.renderPng': 'PNG を生成できませんでした。もう一度お試しください。',
  'errors.placeholder': '内蔵プレースホルダーを利用できません',
  'errors.rowLimit': '1回につき最大 {{max}} 件です。このファイルには {{count}} 件あります',
  'errors.noData': 'ファイルに利用可能なデータがありません',
  'errors.csvParse': 'CSV の {{row}} 行目を解析できませんでした',
  'errors.csvMissingHeaders': 'CSV に必要な見出しがありません：{{fields}}',
  'errors.bindingMissing': '先にテキストへ TXT または CSV のデータ変数を挿入してください',
  'errors.bindingConflict': '{{txt}} と {{csv.*}} は同じテンプレートで併用できません',
  'errors.needTxt': 'このテンプレートは {{txt}} を使用しています。TXT ファイルを読み込んでください',
  'errors.needCsv': 'このテンプレートは CSV フィールドを使用しています。CSV ファイルを読み込んでください',
  'errors.templateTooLarge': 'テンプレートファイルは 1 MB 以下にしてください',
  'errors.templateInvalidJson': 'テンプレートは有効な JSON ファイルではありません',
  'errors.templateFieldInvalid': 'テンプレートのフィールド {{field}} が無効です',
};

const ko: Messages = {
  ...en,
  'meta.title': 'Tsudoi | 시각적 편집 및 일괄 이미지 생성',
  'meta.description': 'Tsudoi는 시각적 텍스트 배치, CSV/TXT 데이터 입력, 고해상도 PNG 및 ZIP 일괄 내보내기를 지원하는 범용 초대장 제작 도구입니다.',
  'app.name': 'Tsudoi',
  'app.subtitle': '비주얼 초대장 도구',
  'language.label': '언어',
  'theme.label': '화면 테마',
  'theme.system': '시스템 설정',
  'theme.light': '라이트',
  'theme.dark': '다크',
  'section.background': '1. 배경 이미지',
  'section.layers': '2. 텍스트 레이어',
  'section.editor': '3. 선택한 텍스트 편집',
  'section.batch': '4. 일괄 데이터',
  'section.single': '5. 단일 다운로드',
  'background.upload': '초대장 배경 업로드',
  'background.padding': '안전 여백',
  'background.helper': '텍스트는 캔버스 가장자리, 중앙, 안전 영역 및 다른 텍스트에 맞춰집니다. Alt 키를 누르면 일시적으로 비활성화됩니다.',
  'layers.add': '텍스트 추가',
  'layers.defaultText': '텍스트',
  'layers.empty': '빈 텍스트',
  'layers.deleteAria': '레이어 #{{index}} 삭제',
  'editor.textAria': '템플릿 텍스트',
  'editor.textPlaceholder': '여러 줄과 변수를 포함한 템플릿 텍스트 입력',
  'editor.tokenHelp': '변수를 삽입하여 일반 텍스트와 자유롭게 조합하세요:',
  'editor.tokenTxt': 'TXT 데이터',
  'editor.tokenDate': '현재 날짜',
  'editor.tokenTime': '현재 시간',
  'editor.tokenDateTime': '날짜와 시간',
  'editor.tokenUuid': '자동 UUID',
  'editor.csvPlaceholder': '예: name',
  'editor.csvAria': 'CSV 헤더',
  'editor.csvInsert': 'CSV 필드 삽입',
  'editor.indexDigits': '일련번호 자릿수',
  'editor.indexInsert': '0 채움 일련번호 삽입',
  'editor.example': '예: {{csv.name}} 님, 날짜 {{date}}, 번호 {{index:3}}',
  'editor.font': '글꼴',
  'editor.fontFallback': '온라인 글꼴을 불러올 수 없으면 같은 언어의 시스템 글꼴을 자동으로 사용합니다.',
  'editor.fontGroupSystem': '시스템 글꼴',
  'editor.fontGroupChinese': '중국어',
  'editor.fontGroupLatin': '라틴 문자',
  'editor.fontGroupJapanese': '일본어',
  'editor.fontGroupKorean': '한국어',
  'editor.fontSystemSans': '시스템 고딕',
  'editor.fontSystemSerif': '시스템 명조',
  'editor.fontSystemKai': '시스템 해서',
  'editor.fontSystemScript': '시스템 필기체',
  'editor.fontGreatVibes': '초대장 필기체',
  'editor.fontPlayfair': '우아한 세리프',
  'editor.fontCormorant': '클래식 세리프',
  'editor.fontSize': '글자 크기',
  'editor.fontWeight': '글자 굵기',
  'editor.weightLight': '얇게',
  'editor.weightRegular': '보통',
  'editor.weightSemibold': '중간 굵게',
  'editor.weightBold': '굵게',
  'editor.color': '색상',
  'editor.alignment': '정렬',
  'editor.alignmentAria': '텍스트 정렬',
  'editor.alignLeft': '왼쪽 정렬',
  'editor.alignCenter': '가운데 정렬',
  'editor.alignRight': '오른쪽 정렬',
  'editor.anchor': '앵커',
  'editor.anchorAria': '{{horizontal}} {{vertical}} 앵커',
  'editor.anchorLeft': '왼쪽',
  'editor.anchorCenter': '가운데',
  'editor.anchorRight': '오른쪽',
  'editor.anchorTop': '위',
  'editor.anchorBottom': '아래',
  'editor.anchorHelp': '앵커는 텍스트 상자의 좌표를 고정하며 줄바꿈된 내용은 해당 지점에서 확장됩니다.',
  'editor.width': '너비',
  'editor.widthAuto': '내용에 맞춤',
  'editor.widthFixed': '고정 너비',
  'editor.pixels': '픽셀',
  'editor.resizeHelp': '파란 원형 핸들을 드래그하면 고정 너비가 되고 핸들이 사각형으로 바뀝니다. 사각형 핸들을 두 번 클릭하면 내용에 맞추기로 돌아갑니다. 캔버스 가장자리, 중앙, 안전 영역, 다른 텍스트에 맞춰지며 Alt 키로 일시 해제할 수 있습니다.',
  'editor.letterSpacing': '자간',
  'editor.stroke': '윤곽선 색상',
  'editor.strokeWidth': '윤곽선 너비',
  'data.import': '{{type}} 가져오기',
  'data.sourceTitle': '데이터 소스 및 예제',
  'data.hint': '템플릿의 {{txt}} 또는 {{csv.헤더}}를 기준으로 데이터 형식을 자동 감지합니다.',
  'data.conflict': 'TXT와 CSV 변수는 함께 사용할 수 없습니다',
  'data.none': '데이터를 가져오기 전에 {{txt}} 또는 {{csv.헤더}}를 삽입하세요',
  'data.imported': '{{type}} 데이터 {{count}}건을 가져왔습니다',
  'data.expandPreview': '미리보기 열기',
  'data.closePreview': '미리보기 닫기',
  'data.previewTitle': '데이터 미리보기 · {{count}}행',
  'data.waiting': '{{type}} 파일을 기다리는 중',
  'data.generating': '생성 중 {{progress}}%',
  'data.download': '일괄 생성 후 ZIP 다운로드',
  'data.examples': '예제 다운로드',
  'data.exampleCsvSingle': 'CSV · 단일 필드',
  'data.exampleCsvMultiple': 'CSV · 다중 필드',
  'data.exampleTxtNames': 'TXT · 이름',
  'data.exampleTxtLines': 'TXT · 전체 텍스트',
  'single.download': '현재 이미지 다운로드',
  'single.help': 'PNG는 항상 배경 이미지의 원본 해상도로 생성되며 모든 파일은 이 기기에서만 처리됩니다.',
  'advanced.title': '고급 기능',
  'advanced.import': '템플릿 가져오기',
  'advanced.export': '템플릿 내보내기',
  'advanced.help': '템플릿은 텍스트 레이어만 교체하며 현재 배경은 그대로 유지합니다.',
  'advanced.reset': '작업 공간 데이터 초기화',
  'footer.github': 'GitHub에서 Tsudoi 소스 코드 보기',
  'footer.navigation': '사이트 정보 및 문의',
  'guide.title': '사용 가이드',
  'footer.about': '소개',
  'footer.privacy': '개인정보',
  'footer.terms': '이용약관',
  'footer.contact': '문의',
  'modal.deleteTitle': '텍스트 레이어를 삭제할까요?',
  'modal.deleteBody': '이 레이어가 삭제됩니다. 데이터 변수가 포함되어 있으면 현재 가져온 데이터도 무효화됩니다.',
  'modal.cancel': '취소',
  'modal.delete': '삭제',
  'modal.templateTitle': '현재 텍스트 레이어를 교체할까요?',
  'modal.templateBody': '템플릿을 가져오면 모든 텍스트 레이어와 안전 여백이 교체되고 배경은 유지됩니다.',
  'modal.import': '템플릿 가져오기',
  'modal.resetTitle': '모든 작업 공간 데이터를 초기화할까요?',
  'modal.resetBody': '배경, 텍스트 레이어, 캔버스 설정, 가져온 데이터와 복구용 저장 데이터를 삭제합니다. 언어와 테마 설정은 유지됩니다.',
  'modal.reset': '데이터 초기화',
  'toast.errorTitle': '작업을 완료하지 못했습니다',
  'toast.unknown': '알 수 없는 오류가 발생했습니다',
  'toast.backgroundLoaded': '배경을 불러왔습니다',
  'toast.dataImported': '데이터를 가져왔습니다',
  'toast.dataImportedMessage': '가져온 레코드: {{count}}',
  'toast.imageGenerated': '이미지를 생성했습니다',
  'toast.imageSaved': 'PNG를 다운로드 폴더에 저장했습니다',
  'toast.batchComplete': '일괄 생성 완료',
  'toast.batchSaved': '이미지 {{count}}장을 ZIP으로 묶었습니다',
  'toast.templateExported': '템플릿을 내보냈습니다',
  'toast.templateExportedMessage': '템플릿에는 배경과 가져온 데이터가 포함되지 않습니다',
  'toast.workspaceReset': '작업 공간 초기화 완료',
  'toast.workspaceResetMessage': '편집기 데이터와 복구용 데이터를 모두 삭제했습니다',
  'pwa.offlineTitle': '오프라인에서 사용할 수 있습니다',
  'pwa.offlineMessage': '편집기 리소스를 이 기기에 저장했습니다.',
  'pwa.updateTitle': '새 버전이 있습니다',
  'pwa.updateMessage': '업데이트 전에 현재 템플릿을 저장하거나 내보내세요.',
  'pwa.updateNow': '지금 업데이트',
  'pwa.later': '나중에',
  'errors.uploadBackgroundFirst': '먼저 실제 배경 이미지를 업로드하세요',
  'errors.dataMismatch': '현재 변수와 일치하는 데이터를 가져오세요',
  'errors.imageFile': '이미지 파일을 선택하세요',
  'errors.imageDecode': '이미지를 열 수 없습니다. 다른 파일을 사용해 보세요.',
  'errors.renderPng': 'PNG를 생성할 수 없습니다. 다시 시도하세요.',
  'errors.placeholder': '내장 플레이스홀더를 사용할 수 없습니다',
  'errors.rowLimit': '한 번에 최대 {{max}}건까지 가능하며 이 파일에는 {{count}}건이 있습니다',
  'errors.noData': '파일에 사용할 수 있는 데이터가 없습니다',
  'errors.csvParse': 'CSV {{row}}행을 분석할 수 없습니다',
  'errors.csvMissingHeaders': 'CSV 헤더가 누락되었습니다: {{fields}}',
  'errors.bindingMissing': '먼저 텍스트에 TXT 또는 CSV 데이터 변수를 삽입하세요',
  'errors.bindingConflict': '{{txt}}와 {{csv.*}}는 하나의 템플릿에서 함께 사용할 수 없습니다',
  'errors.needTxt': '이 템플릿은 {{txt}}를 사용합니다. TXT 파일을 가져오세요',
  'errors.needCsv': '이 템플릿은 CSV 필드를 사용합니다. CSV 파일을 가져오세요',
  'errors.templateTooLarge': '템플릿 파일은 1MB를 초과할 수 없습니다',
  'errors.templateInvalidJson': '템플릿이 올바른 JSON 파일이 아닙니다',
  'errors.templateFieldInvalid': '템플릿 필드 {{field}}이(가) 올바르지 않습니다',
};

const es: Messages = {
  ...en,
  'meta.title': 'Tsudoi | Diseño visual y generación por lotes',
  'meta.description': 'Tsudoi es una herramienta universal para diseñar invitaciones, rellenar datos CSV/TXT y exportar PNG de alta resolución o lotes ZIP.',
  'app.subtitle': 'Estudio visual de invitaciones',
  'language.label': 'Idioma',
  'theme.label': 'Tema visual',
  'theme.system': 'Seguir el sistema',
  'theme.light': 'Claro',
  'theme.dark': 'Oscuro',
  'section.background': '1. Fondo',
  'section.layers': '2. Capas de texto',
  'section.editor': '3. Editar texto seleccionado',
  'section.batch': '4. Datos por lotes',
  'section.single': '5. Descarga individual',
  'background.upload': 'Subir fondo de la invitación',
  'background.padding': 'Margen seguro',
  'background.helper': 'El texto se ajusta a los bordes, el centro, el área segura y otros textos. Mantén Alt para desactivar el ajuste temporalmente.',
  'layers.add': 'Añadir texto',
  'layers.defaultText': 'Texto',
  'layers.empty': 'Texto vacío',
  'layers.deleteAria': 'Eliminar capa #{{index}}',
  'editor.textAria': 'Texto de la plantilla',
  'editor.textPlaceholder': 'Introduce texto de varias líneas y variables',
  'editor.tokenHelp': 'Inserta variables y combínalas libremente con texto normal:',
  'editor.tokenTxt': 'Datos TXT',
  'editor.tokenDate': 'Fecha actual',
  'editor.tokenTime': 'Hora actual',
  'editor.tokenDateTime': 'Fecha y hora',
  'editor.tokenUuid': 'UUID automático',
  'editor.csvPlaceholder': 'p. ej. name',
  'editor.csvAria': 'Cabecera CSV',
  'editor.csvInsert': 'Insertar campo CSV',
  'editor.indexDigits': 'Dígitos del índice',
  'editor.indexInsert': 'Insertar índice con ceros',
  'editor.example': 'Ejemplo: Estimado/a {{csv.name}}, fecha {{date}}, número {{index:3}}',
  'editor.font': 'Fuente',
  'editor.fontFallback': 'Si una fuente en línea no se carga, se utiliza automáticamente una fuente del sistema para el mismo idioma.',
  'editor.fontGroupSystem': 'Fuentes del sistema',
  'editor.fontGroupChinese': 'Chino',
  'editor.fontGroupLatin': 'Latino',
  'editor.fontGroupJapanese': 'Japonés',
  'editor.fontGroupKorean': 'Coreano',
  'editor.fontSystemSans': 'Sans serif del sistema',
  'editor.fontSystemSerif': 'Serif del sistema',
  'editor.fontSystemKai': 'Kai del sistema',
  'editor.fontSystemScript': 'Manuscrita del sistema',
  'editor.fontGreatVibes': 'Caligrafía para invitaciones',
  'editor.fontPlayfair': 'Serif elegante',
  'editor.fontCormorant': 'Serif clásica',
  'editor.fontSize': 'Tamaño',
  'editor.fontWeight': 'Grosor',
  'editor.weightLight': 'Fino',
  'editor.weightRegular': 'Normal',
  'editor.weightSemibold': 'Seminegrita',
  'editor.weightBold': 'Negrita',
  'editor.color': 'Color',
  'editor.alignment': 'Alineación',
  'editor.alignmentAria': 'Alineación del texto',
  'editor.alignLeft': 'Alinear a la izquierda',
  'editor.alignCenter': 'Centrar',
  'editor.alignRight': 'Alinear a la derecha',
  'editor.anchor': 'Ancla',
  'editor.anchorAria': 'Ancla {{horizontal}} {{vertical}}',
  'editor.anchorLeft': 'izquierda',
  'editor.anchorCenter': 'centro',
  'editor.anchorRight': 'derecha',
  'editor.anchorTop': 'arriba',
  'editor.anchorBottom': 'abajo',
  'editor.anchorHelp': 'El ancla fija la coordenada del cuadro; el contenido con saltos se expande desde ese punto.',
  'editor.width': 'Anchura',
  'editor.widthAuto': 'Ajustar al contenido',
  'editor.widthFixed': 'Anchura fija',
  'editor.pixels': 'Píxeles',
  'editor.resizeHelp': 'Arrastra el tirador azul redondo para fijar la anchura; al quedar fija se vuelve cuadrado. Haz doble clic en el tirador cuadrado para volver a ajustar al contenido. Se alinea con bordes, centro, área segura y otros textos; Alt desactiva el ajuste.',
  'editor.letterSpacing': 'Espaciado',
  'editor.stroke': 'Color del contorno',
  'editor.strokeWidth': 'Ancho del contorno',
  'data.import': 'Importar {{type}}',
  'data.sourceTitle': 'Fuente de datos y ejemplos',
  'data.hint': 'La fuente de datos se detecta automáticamente mediante {{txt}} o {{csv.cabecera}} en la plantilla.',
  'data.conflict': 'No se pueden mezclar variables TXT y CSV',
  'data.none': 'Inserta {{txt}} o {{csv.cabecera}} antes de importar datos',
  'data.imported': '{{count}} registros {{type}} importados',
  'data.expandPreview': 'Abrir vista previa',
  'data.closePreview': 'Cerrar vista previa',
  'data.previewTitle': 'Vista previa de datos · {{count}} filas',
  'data.waiting': 'Esperando un archivo {{type}}',
  'data.generating': 'Generando {{progress}}%',
  'data.download': 'Generar lote y descargar ZIP',
  'data.examples': 'Descargar ejemplos',
  'data.exampleCsvSingle': 'CSV · Un campo',
  'data.exampleCsvMultiple': 'CSV · Varios campos',
  'data.exampleTxtNames': 'TXT · Nombres',
  'data.exampleTxtLines': 'TXT · Líneas completas',
  'single.download': 'Descargar imagen actual',
  'single.help': 'El PNG se genera siempre a la resolución original del fondo y todos los archivos permanecen en este dispositivo.',
  'advanced.title': 'Funciones avanzadas',
  'advanced.import': 'Importar plantilla',
  'advanced.export': 'Exportar plantilla',
  'advanced.help': 'La plantilla solo sustituye las capas de texto; el fondo actual no cambia.',
  'advanced.reset': 'Restablecer datos del espacio',
  'footer.github': 'Ver el código fuente de Tsudoi en GitHub',
  'footer.navigation': 'Información del sitio y contacto',
  'guide.title': 'Guía de uso',
  'footer.about': 'Acerca de',
  'footer.privacy': 'Privacidad',
  'footer.terms': 'Términos',
  'footer.contact': 'Contacto',
  'modal.deleteTitle': '¿Eliminar la capa de texto?',
  'modal.deleteBody': 'Se eliminará la capa. Si contiene variables de datos, los datos importados actuales dejarán de ser válidos.',
  'modal.cancel': 'Cancelar',
  'modal.delete': 'Eliminar',
  'modal.templateTitle': '¿Sustituir las capas de texto actuales?',
  'modal.templateBody': 'Importar una plantilla sustituye todas las capas de texto y el margen seguro, pero conserva el fondo.',
  'modal.import': 'Importar plantilla',
  'modal.resetTitle': '¿Restablecer todos los datos del espacio?',
  'modal.resetBody': 'Se eliminarán el fondo, las capas de texto, los ajustes del lienzo, los datos importados y la recuperación local. Se conservarán el idioma y el tema.',
  'modal.reset': 'Restablecer datos',
  'toast.errorTitle': 'Acción no completada',
  'toast.unknown': 'Se produjo un error desconocido',
  'toast.backgroundLoaded': 'Fondo cargado',
  'toast.dataImported': 'Datos importados',
  'toast.dataImportedMessage': 'Registros importados: {{count}}',
  'toast.imageGenerated': 'Imagen generada',
  'toast.imageSaved': 'El PNG se guardó en la carpeta de descargas',
  'toast.batchComplete': 'Generación por lotes completada',
  'toast.batchSaved': 'Imágenes empaquetadas: {{count}}',
  'toast.templateExported': 'Plantilla exportada',
  'toast.templateExportedMessage': 'La plantilla no contiene el fondo ni los datos importados',
  'toast.workspaceReset': 'Espacio restablecido',
  'toast.workspaceResetMessage': 'Se eliminaron los datos del editor y de recuperación',
  'pwa.offlineTitle': 'Disponible sin conexión',
  'pwa.offlineMessage': 'Los recursos del editor se guardaron en este dispositivo.',
  'pwa.updateTitle': 'Hay una nueva versión',
  'pwa.updateMessage': 'Guarda o exporta la plantilla actual antes de actualizar.',
  'pwa.updateNow': 'Actualizar ahora',
  'pwa.later': 'Más tarde',
  'errors.uploadBackgroundFirst': 'Sube primero una imagen de fondo real',
  'errors.dataMismatch': 'Importa datos que coincidan con las variables actuales',
  'errors.imageFile': 'Selecciona un archivo de imagen',
  'errors.imageDecode': 'No se pudo abrir la imagen. Prueba con otro archivo.',
  'errors.renderPng': 'No se pudo generar el PNG. Inténtalo de nuevo.',
  'errors.placeholder': 'El marcador de posición integrado no está disponible',
  'errors.rowLimit': 'Cada lote admite hasta {{max}} registros; este archivo contiene {{count}}',
  'errors.noData': 'El archivo no contiene datos utilizables',
  'errors.csvParse': 'No se pudo analizar la fila {{row}} del CSV',
  'errors.csvMissingHeaders': 'Faltan cabeceras CSV: {{fields}}',
  'errors.bindingMissing': 'Inserta primero una variable de datos TXT o CSV en el texto',
  'errors.bindingConflict': '{{txt}} y {{csv.*}} no pueden mezclarse en una plantilla',
  'errors.needTxt': 'Esta plantilla utiliza {{txt}}; importa un archivo TXT',
  'errors.needCsv': 'Esta plantilla utiliza campos CSV; importa un archivo CSV',
  'errors.templateTooLarge': 'El archivo de plantilla no puede superar 1 MB',
  'errors.templateInvalidJson': 'La plantilla no es un archivo JSON válido',
  'errors.templateFieldInvalid': 'El campo de plantilla {{field}} no es válido',
};

const fr: Messages = {
  ...en,
  'meta.title': 'Tsudoi | Mise en page visuelle et génération par lot',
  'meta.description': 'Tsudoi est un outil universel de création d’invitations avec mise en page visuelle, données CSV/TXT et export PNG haute résolution ou ZIP.',
  'app.subtitle': 'Studio visuel d’invitations',
  'language.label': 'Langue',
  'theme.label': 'Thème visuel',
  'theme.system': 'Suivre le système',
  'theme.light': 'Clair',
  'theme.dark': 'Sombre',
  'section.background': '1. Arrière-plan',
  'section.layers': '2. Calques de texte',
  'section.editor': '3. Modifier le texte sélectionné',
  'section.batch': '4. Données par lot',
  'section.single': '5. Téléchargement unique',
  'background.upload': 'Importer l’arrière-plan de l’invitation',
  'background.padding': 'Marge de sécurité',
  'background.helper': 'Le texte s’aligne sur les bords, le centre, la zone sûre et les autres textes. Maintenez Alt pour désactiver temporairement l’alignement.',
  'layers.add': 'Ajouter du texte',
  'layers.defaultText': 'Texte',
  'layers.empty': 'Texte vide',
  'layers.deleteAria': 'Supprimer le calque n° {{index}}',
  'editor.textAria': 'Texte du modèle',
  'editor.textPlaceholder': 'Saisissez du texte sur plusieurs lignes avec des variables',
  'editor.tokenHelp': 'Insérez des variables et combinez-les librement avec du texte :',
  'editor.tokenTxt': 'Données TXT',
  'editor.tokenDate': 'Date actuelle',
  'editor.tokenTime': 'Heure actuelle',
  'editor.tokenDateTime': 'Date et heure',
  'editor.tokenUuid': 'UUID automatique',
  'editor.csvPlaceholder': 'p. ex. name',
  'editor.csvAria': 'En-tête CSV',
  'editor.csvInsert': 'Insérer un champ CSV',
  'editor.indexDigits': 'Chiffres de remplissage',
  'editor.indexInsert': 'Insérer un index complété',
  'editor.example': 'Exemple : Bonjour {{csv.name}}, date {{date}}, numéro {{index:3}}',
  'editor.font': 'Police',
  'editor.fontFallback': 'Si une police en ligne ne se charge pas, une police système adaptée à la langue est utilisée automatiquement.',
  'editor.fontGroupSystem': 'Polices système',
  'editor.fontGroupChinese': 'Chinois',
  'editor.fontGroupLatin': 'Latin',
  'editor.fontGroupJapanese': 'Japonais',
  'editor.fontGroupKorean': 'Coréen',
  'editor.fontSystemSans': 'Sans serif système',
  'editor.fontSystemSerif': 'Serif système',
  'editor.fontSystemKai': 'Kai système',
  'editor.fontSystemScript': 'Manuscrite système',
  'editor.fontGreatVibes': 'Calligraphie d’invitation',
  'editor.fontPlayfair': 'Serif élégante',
  'editor.fontCormorant': 'Serif classique',
  'editor.fontSize': 'Taille',
  'editor.fontWeight': 'Graisse',
  'editor.weightLight': 'Fine',
  'editor.weightRegular': 'Normale',
  'editor.weightSemibold': 'Demi-grasse',
  'editor.weightBold': 'Grasse',
  'editor.color': 'Couleur',
  'editor.alignment': 'Alignement',
  'editor.alignmentAria': 'Alignement du texte',
  'editor.alignLeft': 'Aligner à gauche',
  'editor.alignCenter': 'Centrer',
  'editor.alignRight': 'Aligner à droite',
  'editor.anchor': 'Ancre',
  'editor.anchorAria': 'Ancre {{horizontal}} {{vertical}}',
  'editor.anchorLeft': 'gauche',
  'editor.anchorCenter': 'centre',
  'editor.anchorRight': 'droite',
  'editor.anchorTop': 'haut',
  'editor.anchorBottom': 'bas',
  'editor.anchorHelp': 'L’ancre fixe les coordonnées du bloc ; le contenu à la ligne s’étend depuis ce point.',
  'editor.width': 'Largeur',
  'editor.widthAuto': 'Selon le contenu',
  'editor.widthFixed': 'Largeur fixe',
  'editor.pixels': 'Pixels',
  'editor.resizeHelp': 'Faites glisser la poignée bleue ronde pour définir une largeur fixe ; elle devient carrée une fois fixée. Double-cliquez sur la poignée carrée pour réadapter la largeur au contenu. Elle s’aligne sur les bords, le centre, la zone sûre et les autres textes ; Alt désactive l’alignement.',
  'editor.letterSpacing': 'Espacement',
  'editor.stroke': 'Couleur du contour',
  'editor.strokeWidth': 'Largeur du contour',
  'data.import': 'Importer {{type}}',
  'data.sourceTitle': 'Source de données et exemples',
  'data.hint': 'La source de données est détectée automatiquement via {{txt}} ou {{csv.entête}} dans le modèle.',
  'data.conflict': 'Les variables TXT et CSV ne peuvent pas être mélangées',
  'data.none': 'Insérez {{txt}} ou {{csv.entête}} avant d’importer des données',
  'data.imported': '{{count}} enregistrements {{type}} importés',
  'data.expandPreview': 'Ouvrir l’aperçu',
  'data.closePreview': 'Fermer l’aperçu',
  'data.previewTitle': 'Aperçu des données · {{count}} lignes',
  'data.waiting': 'En attente d’un fichier {{type}}',
  'data.generating': 'Génération {{progress}} %',
  'data.download': 'Générer le lot et télécharger le ZIP',
  'data.examples': 'Télécharger des exemples',
  'data.exampleCsvSingle': 'CSV · Un champ',
  'data.exampleCsvMultiple': 'CSV · Plusieurs champs',
  'data.exampleTxtNames': 'TXT · Noms',
  'data.exampleTxtLines': 'TXT · Lignes complètes',
  'single.download': 'Télécharger l’image actuelle',
  'single.help': 'Le PNG est toujours généré à la résolution d’origine de l’arrière-plan et tous les fichiers restent sur cet appareil.',
  'advanced.title': 'Fonctions avancées',
  'advanced.import': 'Importer un modèle',
  'advanced.export': 'Exporter le modèle',
  'advanced.help': 'Le modèle remplace uniquement les calques de texte ; l’arrière-plan actuel reste inchangé.',
  'advanced.reset': 'Réinitialiser les données',
  'footer.github': 'Voir le code source de Tsudoi sur GitHub',
  'footer.navigation': 'Informations du site et contact',
  'guide.title': 'Guide d’utilisation',
  'footer.about': 'À propos',
  'footer.privacy': 'Confidentialité',
  'footer.terms': 'Conditions',
  'footer.contact': 'Contact',
  'modal.deleteTitle': 'Supprimer le calque de texte ?',
  'modal.deleteBody': 'Le calque sera supprimé. S’il contient des variables de données, les données importées actuelles deviendront également invalides.',
  'modal.cancel': 'Annuler',
  'modal.delete': 'Supprimer',
  'modal.templateTitle': 'Remplacer les calques de texte actuels ?',
  'modal.templateBody': 'L’importation d’un modèle remplace tous les calques de texte et la marge de sécurité, tout en conservant l’arrière-plan.',
  'modal.import': 'Importer le modèle',
  'modal.resetTitle': 'Réinitialiser toutes les données de l’espace ?',
  'modal.resetBody': 'L’arrière-plan, les calques de texte, les réglages du canevas, les données importées et la sauvegarde locale seront supprimés. La langue et le thème seront conservés.',
  'modal.reset': 'Réinitialiser',
  'toast.errorTitle': 'Action non terminée',
  'toast.unknown': 'Une erreur inconnue est survenue',
  'toast.backgroundLoaded': 'Arrière-plan chargé',
  'toast.dataImported': 'Données importées',
  'toast.dataImportedMessage': 'Enregistrements importés : {{count}}',
  'toast.imageGenerated': 'Image générée',
  'toast.imageSaved': 'Le PNG a été enregistré dans le dossier des téléchargements',
  'toast.batchComplete': 'Génération par lot terminée',
  'toast.batchSaved': 'Images regroupées : {{count}}',
  'toast.templateExported': 'Modèle exporté',
  'toast.templateExportedMessage': 'Le modèle ne contient ni l’arrière-plan ni les données importées',
  'toast.workspaceReset': 'Espace réinitialisé',
  'toast.workspaceResetMessage': 'Les données de l’éditeur et de récupération ont été supprimées',
  'pwa.offlineTitle': 'Disponible hors connexion',
  'pwa.offlineMessage': 'Les ressources de l’éditeur ont été enregistrées sur cet appareil.',
  'pwa.updateTitle': 'Une nouvelle version est disponible',
  'pwa.updateMessage': 'Enregistrez ou exportez le modèle actuel avant la mise à jour.',
  'pwa.updateNow': 'Mettre à jour',
  'pwa.later': 'Plus tard',
  'errors.uploadBackgroundFirst': 'Importez d’abord une véritable image d’arrière-plan',
  'errors.dataMismatch': 'Importez des données correspondant aux variables actuelles',
  'errors.imageFile': 'Sélectionnez un fichier image',
  'errors.imageDecode': 'Impossible d’ouvrir l’image. Essayez un autre fichier.',
  'errors.renderPng': 'Impossible de générer le PNG. Réessayez.',
  'errors.placeholder': 'L’image de substitution intégrée est indisponible',
  'errors.rowLimit': 'Un lot accepte jusqu’à {{max}} enregistrements ; ce fichier en contient {{count}}',
  'errors.noData': 'Le fichier ne contient aucune donnée utilisable',
  'errors.csvParse': 'Impossible d’analyser la ligne CSV {{row}}',
  'errors.csvMissingHeaders': 'En-têtes CSV manquants : {{fields}}',
  'errors.bindingMissing': 'Insérez d’abord une variable de données TXT ou CSV dans le texte',
  'errors.bindingConflict': '{{txt}} et {{csv.*}} ne peuvent pas être mélangés dans un même modèle',
  'errors.needTxt': 'Ce modèle utilise {{txt}} ; importez un fichier TXT',
  'errors.needCsv': 'Ce modèle utilise des champs CSV ; importez un fichier CSV',
  'errors.templateTooLarge': 'Le fichier de modèle ne peut pas dépasser 1 Mo',
  'errors.templateInvalidJson': 'Le modèle n’est pas un fichier JSON valide',
  'errors.templateFieldInvalid': 'Le champ de modèle {{field}} n’est pas valide',
};

export const resources = {
  'zh-CN': { translation: zhCN },
  'zh-TW': { translation: zhTW },
  en: { translation: en },
  de: { translation: de },
  ja: { translation: ja },
  ko: { translation: ko },
  es: { translation: es },
  fr: { translation: fr },
} as const;

export type AppLanguage = keyof typeof resources;
export type TranslationKey = keyof typeof en;
